import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { uploadPhotos } from './utils';

export default function* listenUploadPhotos() {
  yield takeEvery(actionTypes.UPLOAD_PHOTOS, uploadPhotos);
}
